<template>
  <div>
    <div style="display: flex; justify-content: center">
      <div class="card-box pl-4 pr-4">
        <div>
          <div
            class="mt-3 ml-3"
            v-if="content == '' && isLoading == false"
            style="color: grey"
          >
            Text example is here...
          </div>
          <div
            class="mt-3 content-html"
            v-html="content"
            v-else
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { coreInstance, backendVersion } from "@/axios-path.js";
import "highlight.js/styles/tomorrow.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  data() {
    return {
      content: "",
      isLoading: false,
    };
  },
  computed: {},
  methods: {},
  async created() {
    this.isLoading = true;
    await coreInstance
      .get(
        backendVersion.version + "/getInboxById/" + this.$route.params.blog_id
      )
      .then((res) => {
        this.content = res.data.data.notification_inbox_html;
      })
      .catch((err) => console.log(err));
    this.isLoading = false;
  },
};
</script>

<style scoped>
.card-box {
  min-height: 100vh;
  width: 100%;
  max-width: 1200px;
  padding: 0 15px;
  box-sizing: border-box;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .card-box {
    padding: 0 10px;
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .card-box {
    padding: 0 8px;
  }
}
</style>

<style>
.content-html img {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
}

/* Mobile-first responsive typography and spacing */
.content-html {
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.content-html h1 {
  font-size: 24px;
  line-height: 1.2;
  margin: 20px 0 15px 0;
}

.content-html h2 {
  font-size: 20px;
  line-height: 1.3;
  margin: 18px 0 12px 0;
}

.content-html h3 {
  font-size: 18px;
  line-height: 1.3;
  margin: 16px 0 10px 0;
}

.content-html p {
  margin: 12px 0;
  font-size: 16px;
  line-height: 1.7;
}

.content-html div {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .content-html {
    font-size: 15px;
  }
  
  .content-html h1 {
    font-size: 22px;
    margin: 16px 0 12px 0;
  }
  
  .content-html h2 {
    font-size: 19px;
    margin: 14px 0 10px 0;
  }
  
  .content-html h3 {
    font-size: 17px;
    margin: 12px 0 8px 0;
  }
  
  .content-html p {
    font-size: 15px;
    line-height: 1.6;
    margin: 10px 0;
  }
}

@media (max-width: 480px) {
  .content-html {
    font-size: 14px;
  }
  
  .content-html h1 {
    font-size: 20px;
    margin: 14px 0 10px 0;
  }
  
  .content-html h2 {
    font-size: 18px;
    margin: 12px 0 8px 0;
  }
  
  .content-html h3 {
    font-size: 16px;
    margin: 10px 0 6px 0;
  }
  
  .content-html p {
    font-size: 14px;
    line-height: 1.5;
    margin: 8px 0;
  }
}
</style>